import { useEffect, type ReactNode } from "react";
import AgeVerificationModal from "../AgeVerificationModal/AgeVerificationModal";
import { useAppDispatch } from "../../../hooks/redux";
import { setLoaderState } from "../../../store/slices/loaderSlice";
import { Container } from "../../common/HtmlTags/Container/Container";
import "./OnboardingGate.css";

const ONBOARDING_OVERLAY_Z_INDEX = 10049;
const ONBOARDING_MODAL_Z_INDEX = 10050;

type OnboardingGateProps = {
  userId: string | null;
  onSuccess: () => Promise<void>;
  children: ReactNode;
};

export default function OnboardingGate({
  userId,
  onSuccess,
  children,
}: OnboardingGateProps) {
  const dispatch = useAppDispatch();
  const isBlocking = userId !== null;

  useEffect(() => {
    if (!isBlocking) {
      return;
    }

    dispatch(setLoaderState(false));
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [dispatch, isBlocking]);

  return (
    <>
      {children}
      {isBlocking && (
        <>
          <Container
            data-testid="onboarding-gate-overlay"
            className="onboarding-gate-overlay"
            style={{ zIndex: ONBOARDING_OVERLAY_Z_INDEX }}
            aria-hidden="true"
            decorativeContainer
          />
          <AgeVerificationModal
            open
            userId={userId}
            onSuccess={onSuccess}
            zIndex={ONBOARDING_MODAL_Z_INDEX}
          />
        </>
      )}
    </>
  );
}
